import React, { useState, useEffect } from 'react'
import { driversService } from '../../_services/drivers.service'
import { NumberInput, NUMBER_FORMAT_LATIN } from 'react-hichestan-numberinput'
import InputMask from 'react-input-mask';
import BankSelect from '../Shared/BankSelect'
import { AiOutlineLoading, AiOutlineSave } from "react-icons/ai"
import { toastr } from 'react-redux-toastr'
import Loading from '../Shared/Loading'

import { Formik, Field, getIn, ErrorMessage } from 'formik'
import * as Yup from 'yup'
import ErrorPopUp from '../Shared/ErrorPopUp'

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import DialogTitle from '@material-ui/core/DialogTitle';
import Fab from '@material-ui/core/Fab'
import { MdClose } from 'react-icons/md'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const initialData = {
  name: '', mobile: '', bankId: ''
}

export default function ClientFormDialog(props) {
  const [loading, setLoading] = useState(false)
  const [dialogShow, setDialogShow] = useState(props.show || false)
  const [data, setData] = useState(initialData)
  const [id, setId] = useState(props.id)

  useEffect(() => {

    setData(initialData)
    setDialogShow(props.show)

    if (props.id) {
      setId(props.id)
      getData()
    } else {
      setData(initialData)
    }

  }, [props.show, props.id])

  const getData = () => {
    setLoading(true)
    driversService.getById(props.id)
      .then((res) => {
        console.log(res.data)
        setData(res.data)
        setLoading(false)
      })
      .catch((error) => {
        console.log(error)
        setLoading(false)
      });
  }

  const handleSubmit = (values, setSubmitting) => {
    setLoading(true)
    // console.log(JSON.stringify(values));

    if (values.id) {

      driversService.edit(values.id, JSON.stringify(values))
        .then((res) => {

          if (res.data === 1) {
            toastr.success('ویرایش راننده', 'راننده "' + values.name + '" با موفقیت ویرایش شد');
            props.handleModalHideAndReload()
          } else if (res.data === -1) {
            toastr.warning("این شماره موبایل قبلا ثبت شده است")
          }

        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setLoading(false)
          setSubmitting(false)
        });

    } else {
      console.log(JSON.stringify(values));
      driversService.add(JSON.stringify(values))
        .then((res) => {

          if (res.data === 1) {
            toastr.success('ثبت راننده جدید', 'راننده "' + res.data.name + '" با موفقیت ثبت شد');
            props.handleModalHideAndReload()
          } else if (res.data === -1) {
            toastr.warning("این شماره موبایل قبلا ثبت شده است")
          }

        })
        .catch((error) => {
          console.log(error)
        })
        .finally(() => {
          setLoading(false)
          setSubmitting(false)
        });

    }
  }

  const ValidationSchema = Yup.object().shape({
    name: Yup.string().trim().nullable().required('نام و نام خانوادگی راننده'),
    mobile: Yup.string().trim().nullable().required('موبایل راننده'),
    bankId: Yup.string().trim().nullable().required('نام بانک'),
  })

  return (

    <Dialog
      open={dialogShow}
      onClose={props.handleModalHide}
      TransitionComponent={Transition}
      scroll={'paper'}
      fullWidth={true}
      maxWidth="md"
      aria-labelledby="scroll-dialog-title"
      aria-describedby="scroll-dialog-description">
      <DialogTitle>
        <Fab color="secondary" aria-label="refresh" size="small" onClick={() => props.handleModalHide()} className="modal-close-btn">
          <MdClose size="20px" />
        </Fab>
        <span style={{ marginRight: 10 }}></span>
      </DialogTitle>
      <DialogContent dividers={true}>

        <Formik
          initialValues={data}
          enableReinitialize
          onSubmit={(values, { setSubmitting }) => {
            // // console.log(values);
            handleSubmit(values, setSubmitting)
          }}
          validationSchema={ValidationSchema}
        >
          {props => {
            const {
              values,
              touched,
              errors,
              isSubmitting,
              handleChange,
              handleBlur,
              setFieldValue,
              handleSubmit,
            } = props;
            return (

              <div className="row" style={{ position: "relative" }}>
                <div className="col-md-12">
                  <form onSubmit={handleSubmit}>

                    <div className="row">
                      <div className="form-inline">

                        <div className="col-md-4 col-sm-12">
                          <label>نام و نام خانوادگی راننده</label>
                          <Field type="text"
                            autoFocus
                            name="name"
                            className={
                              getIn(errors, "name") &&
                                getIn(touched, "name")
                                ? "text-input has-error "
                                : "text-input required "
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="name" />
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <label>موبایل راننده</label>
                          <NumberInput autoFocus type='tel' className="latin-number" maxLength="11" name="mobile"
                            autoComplete="off" numberFormat={NUMBER_FORMAT_LATIN}
                            value={values.mobile}
                            maxLength={11}

                            // placeholder="شماره موبایل خود را وارد نمایید"
                            onChange={e => setFieldValue("mobile", e.target.value)}
                            className={
                              getIn(errors, "mobile") &&
                                getIn(touched, "mobile")
                                ? "text-input has-error ltr"
                                : "text-input required ltr"
                            }
                          />

                          <ErrorMessage component={ErrorPopUp} name="mobile" />
                        </div>

                        <div className="clearfix form-row"></div>

                        <div className="col-md-4 col-sm-12">
                          <label>نام بانک</label>
                          <BankSelect
                            onChange={(val) => {
                              setFieldValue('bankId', val ? val.value : '')
                            }}
                            defaultValue={values.bankId}
                          />
                          <ErrorMessage component={ErrorPopUp} name="bankId" />
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <label>شماره حساب</label>
                          <NumberInput type='tel'
                            value={values.accountNumber}
                            onChange={e => {
                              setFieldValue("accountNumber", e.target.value)
                            }}
                            className={
                              getIn(errors, "accountNumber") &&
                                getIn(touched, "accountNumber")
                                ? "text-input has-error ltr"
                                : "text-input required ltr"
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="accountNumber" />
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <label>شماره کارت</label>
                          <NumberInput type='tel'
                            value={values.cardNumber}
                            onChange={e => {
                              setFieldValue("cardNumber", e.target.value)
                            }}
                            className={
                              getIn(errors, "cardNumber") &&
                                getIn(touched, "cardNumber")
                                ? "text-input has-error ltr"
                                : "text-input required ltr"
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="cardNumber" />
                        </div>

                        <div className="clearfix"></div>

                        <div className="col-md-4 col-sm-12">
                          <label>شماره شبا</label>
                          <NumberInput type='tel'
                            value={values.shebaNumber}
                            onChange={e => {
                              setFieldValue("shebaNumber", e.target.value)
                            }}
                            className={
                              getIn(errors, "shebaNumber") &&
                                getIn(touched, "shebaNumber")
                                ? "text-input has-error ltr"
                                : "text-input required ltr"
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="shebaNumber" />
                        </div>

                        <div className="col-md-4 col-sm-12">
                          <label>شماره پلاک ماشین</label>
                          <InputMask
                            mask="999 a 99"
                            maskChar={null}
                            value={values.pelak}
                            onChange={e => {
                              console.log(e.target.value)
                              setFieldValue("pelak", e.target.value)
                            }}
                            alwaysShowMask
                            // beforeMaskedValueChange={this.beforeMaskedValueChange}
                            formatChars={{
                              // '9': '[0-9۰-۹]',
                              '9': '[0-9]',
                              'a': /^[\u0600-\u06FF\s]+$/,
                            }}
                            className={
                              getIn(errors, "pelak") &&
                                getIn(touched, "pelak")
                                ? "text-input has-error rtl"
                                : "text-input required rtl"
                            }
                          />
                          <ErrorMessage component={ErrorPopUp} name="pelak" />
                        </div>

                        <div className="clearfix"></div>

                        <div className="col-md-12">
                          <button type="submit" className={"icon button submit-btn " + (isSubmitting ? "isSubmitting" : "")} disabled={isSubmitting}>
                            {isSubmitting ?
                              <AiOutlineLoading className="mdi-spin" size="22px" />
                              :
                              <AiOutlineSave size="22px" />
                            }ذخیره</button>
                        </div>
                        <div className="clearfix form-row"></div>

                      </div>
                    </div>

                  </form>

                  {loading ? <Loading /> : ''}
                </div>
              </div>

            );
          }}
        </Formik>

      </DialogContent>
    </Dialog >

  )
}